var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"c_event"},[_c('i',{staticClass:"far fa-calendar-alt"}),_c('div',[_c('p',[_vm._v("Host an event and invite your network and peers")]),_c('c-button',{staticClass:"hover_btn",attrs:{"size":"sm","variant-color":"vc-orange","variant":"outline"},on:{"click":_vm.openCreateEventModal}},[_vm._v(" Create an Event ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }